var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxlength":_vm.maxLength},on:{"input":_vm.changeValue}})}
var staticRenderFns = []

export { render, staticRenderFns }